// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoModal_root__lKNnV","layout":"VideoModal_layout__PW4Bz","close":"VideoModal_close__7PHTD","iframe":"VideoModal_iframe__beKP_","rotation":"VideoModal_rotation__WX8_m"};